// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__cVLG5","overlayOpen":"Modal_overlayOpen__iJW_c","overlay":"Modal_overlay__m2ezw","close":"Modal_close__lyf7J"};